export default __webpack_public_path__ + "static/media/send.af26b88a.svg";